import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { I18nextProvider } from 'react-i18next';
import 'leaflet/dist/leaflet.css';

// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './styles/index.scss';
import i18n from './i18n';
import App from './app';

const target = document.querySelector('#root');
const history = createBrowserHistory();


render(
  <Router history={ history }>
    <I18nextProvider i18n={ i18n }>
      <App />
    </I18nextProvider>
  </Router>
  ,
  target
);
